import { render } from "./AddYacht.vue?vue&type=template&id=7e715256"
import script from "./AddYacht.vue?vue&type=script&lang=js"
export * from "./AddYacht.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__